export default __webpack_public_path__ + "static/media/check-list.73c12c83.png";